import React, { Component } from 'react';
import { contactData } from '../Contacts/contact-data';

import './Band.css';
import Directors from '../Tools/Directors';
import FullDirectory from '../Directory/FullDirectory/FullDirectory';
import High from './BandHigh';
import Middle from './BandMiddle';

import { FILE } from '../../utils/constants/pdf';

export default class Band extends Component {
  state = {
    high: false,
    middle: false,
    directory: false,
    directors: [],
    department: 'Band',
    files: {
      marching: [
        {
          title: '5A Marching Contest Schedule 2025',
          href: FILE.marching_contest_5a_2025,
        },
        {
          title: '6A Marching Contest Schedule',
          href: FILE.marchingContestSched6a24,
        },
        { title: 'Marching Host Guidelines', href: FILE.marchingHost },
        {
          title: 'Instructions for Entering Marching Band Contest',
          href: FILE.entranceInstructions,
        },
        { title: 'UIL Marching Band Script', href: FILE.script },
        { title: 'Statement of Compliance', href: FILE.directorsCompliance },
        { title: 'Marching Band Electronics FAQ', href: FILE.electronics },
        { title: 'Video Policy', href: FILE.videoPolicy },
        { title: 'UIL Region Adjudication Sheet', href: FILE.regionMarchingAdjudication },
        {
          title: 'UIL Area State Adjudication Sheet (5 panel)',
          href: FILE.areaState5AdSheet,
        },
        {
          title: 'UIL State Adjudication Sheet (7 panel)',
          href: FILE.stateAd7Sheet,
        },
        {
          title: 'State Military Marching Band Contest Pilot',
          href: FILE.militaryBandPilot,
        },
        {
          title: 'Marching Band Educational Use Video Agreement',
          href: FILE.educationUseVideo,
        },
      ],
      solo: [
        {
          title: 'Solo & Ensemble Entering Instructions',
          href: FILE.allSoloEntrance,
        },
        {
          title: 'Solo & Ensemble Host Guidelines',
          href: FILE.seHostGuidelines,
        },
        {
          title: 'Solo & Ensemble Event Codes',
          href: FILE.soloEventCodes,
        },
        {
          title: 'State Instrumental Chamber Music Contest',
          href: FILE.chamberMusic,
        },
      ],
      concert: [
        {
          title: 'UIL SightReading Instruction Pilot',
          href: FILE.sightreadingPilot,
        },
        {
          title: 'Concert & SightReading Entering Instructions',
          href: FILE.allContestEntrance,
        },
        {
          title: 'Concert & SightReading Host Guidelines',
          href: FILE.concertHostGuidelines,
        },
        {
          title: 'Updates for UIL Sightreading',
          href: FILE.uilSightreadingUpdates,
        },
        // 24-25
        {
          title: 'Band Concert Evaluation',
          href: FILE.bandConcertEval24,
        },
        {
          title: 'Band Sight Reading Rubric',
          href: FILE.bandSightReading,
        },
        {
          title: 'Band Form 4',
          href: FILE.bandForm4,
        },
        {
          title: 'Band Form 5',
          href: FILE.bandForm5,
        },
      ],
      schedules: [
        // { title: '2022/2023 Contest Schedule', href: FILE.contestSchedule },
      ],
      middleSolo: [
        {
          title: 'Solo & Ensemble Host Guidelines',
          href: FILE.seHostGuidelines,
        },
        {
          title: 'Solo & Ensemble Event Codes',
          href: FILE.soloEventCodes,
        },
        {
          title: 'State Instrumental Chamber Music Contest',
          href: FILE.chamberMusic,
        },
      ],
      middleConcert: [
        {
          title: 'UIL SightReading Instruction Pilot',
          href: FILE.sightreadingPilot,
        },
        {
          title: 'Concert & SightReading Entering Instructions',
          href: FILE.allContestEntrance,
        },
        {
          title: 'Updates for UIL Sightreading',
          href: FILE.uilSightreadingUpdates,
        },
        // 24-25
        {
          title: 'Band Concert Evaluation',
          href: FILE.bandConcertEval24,
        },
        {
          title: 'Band Sight Reading Rubric',
          href: FILE.bandSightReading,
        },
        {
          title: 'Band Form 4',
          href: FILE.bandForm4,
        },
        {
          title: 'Band Form 5',
          href: FILE.bandForm5,
        },
      ],
    },
    scales: [
      'Oboe',
      'Bassoon',
      'Clarinet',
      'Bass Clarinet',
      'Alto/Bari Saxophone',
      'Tenor Saxophone',
      'Trumpet',
      'French Horn',
      'Trombone/Euphonium',
      'Tuba',
    ],
  };

  componentDidMount() {
    this.getContacts();
  }

  async getContacts() {
    const band = 'Band';
    try {
      // let contacts = await axios(`/api/contacts?department=${band}`);
      const contactsFilter = contactData[0].filter(el => el.department === 'BAND')
      this.setState({ directors: contactsFilter });
    } catch (err) {
      console.log(err);
    }
  }

  toggleClick = (a, b, c) => {
    this.setState({
      high: a,
      middle: b,
      directory: c,
    });
  };

  render() {
    const { high, middle, directory, directors, files, scales } = this.state;

    return (
      <div className="band_main">
        <div className="component_img" />
        <div className="band_content">
          {/* main header */}
          <div className="band_header">
            <div className="band_header_container">
              <h1
                className="band_link a"
                onClick={() => this.toggleClick(false, false, false)}
              >
                Band
              </h1>
              <div className="band_sub_nav">
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(true, false, false)}
                >
                  High School
                </h2>
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, true, false)}
                >
                  Middle School
                </h2>
                {/* <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, false, true)}
                >
                  Directory
                </h2> */}
              </div>
            </div>
          </div>
          {/* hidden header */}
          <div className="band_header_small">
            <h1
              className="band_link a big-link"
              onClick={() => this.toggleClick(false, false, false)}
            >
              Band
            </h1>
            <h2
              className="band_link a side-link"
              onClick={() => this.toggleClick(true, false, false)}
            >
              High School
            </h2>
            <h2
              className="band_link a side-link"
              onClick={() => this.toggleClick(false, true, false)}
            >
              Middle School
            </h2>
            {/* <h2
              className="band_link a side-link"
              onClick={() => this.toggleClick(false, false, true)}
            >
              Directory
            </h2> */}
          </div>
          {!high && !middle && !directory && (
            <div className="band_home scroll">
              <div className="division-container">
                <h2>
                  All High School and Middle School events will be split up into
                  North/South zones.
                </h2>
                <h4>Check the following links to see the divisions.</h4>
                <ul className="band-division-links">
                  <li>
                    <a href={FILE.highSchoolDivisions} target="blank">
                      High School
                    </a>
                  </li>
                  <li>
                    <a href={FILE.middleSchoolDivisions} target="blank">
                      Middle School
                    </a>
                  </li>
                </ul>
              </div>
              <div className="band-director-form">
                <h2>
                  Click the link to add your information to the directory.
                </h2>
                <div className="band-link-container">
                  <a
                    href="https://forms.gle/ciXWNMQ4jDzuYrK88"
                    target="blank"
                    className="form_link band_form_link"
                  >
                    Band Director Information Form
                  </a>
                </div>
                <ul className="band-main-links" style={{ flexDirection: 'column', alignItems: 'center' }}>
                  <li className="band-link home-info">
                    <a href={FILE.band_policies_25} target="blank">
                    Region 20 Band Policies and Procedures
                    </a>
                  </li>
                  <li className="band-link home-info">
                    <a href="https://drive.google.com/drive/folders/1MhMI9E1xaWMqZDHtXFy4M2KFl2FpyIFZ?usp=sharing" target="blank">
                    Region 20 Band Finance Reports
                    </a>
                  </li>
                </ul>
              </div>
              <h2>Our Directors</h2>
              <div className="map_holder">
                <Directors directors={directors} />
              </div>
            </div>
          )}

          {high && <High files={files} />}

          {middle && <Middle scales={scales} files={files} />}
          {directory && (
            <div className="band_middle scroll">
              <h2 className="band_title">Directory</h2>
              <FullDirectory department={this.state.department} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Band/Band.js